document.addEventListener("DOMContentLoaded", function () {
    const logoColumns = document.querySelectorAll(".logo-column");

    logoColumns.forEach((column, columnIndex) => {
        const elements = column.children;
        let activeIndex = 0;

        elements[0].classList.add("active");

        function cycleElements() {
            Array.from(elements).forEach((element, index) => {
                element.classList.remove("active");
            });

            elements[activeIndex].classList.add("active");

            activeIndex = (activeIndex + 1) % elements.length;
        }

        setInterval(cycleElements, 4500 + columnIndex * 900);
    });
});
